module.exports = __webpack_public_path__ + "41fd6dbfcb7c4ed0d2a214e0236cca13.pdf";